/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VitalScoreStrictHttpResponse } from '../../vital-score-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DashboardItemModel } from '../../models/dashboard-item-model';
import { DashboardRequestModel } from '../../models/dashboard-request-model';

export interface DashboardHealthScoreOrganizationIdPost$Params {
  organizationId: string;
      body?: DashboardRequestModel
}

export function dashboardHealthScoreOrganizationIdPost(http: HttpClient, rootUrl: string, params: DashboardHealthScoreOrganizationIdPost$Params, context?: HttpContext): Observable<VitalScoreStrictHttpResponse<Array<DashboardItemModel>>> {
  const rb = new RequestBuilder(rootUrl, dashboardHealthScoreOrganizationIdPost.PATH, 'post');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VitalScoreStrictHttpResponse<Array<DashboardItemModel>>;
    })
  );
}

dashboardHealthScoreOrganizationIdPost.PATH = '/Dashboard/HealthScore/{organizationId}';
